import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useParams } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import HomePage from "@/pages/HomePage";
import NichePage from "@/pages/NichePage";
import ServicePage from "@/pages/ServicePage";
import MtdPage from "@/pages/MtdPage";
import BlogIndexPage from "@/pages/BlogIndexPage";
import BlogPostPage from "@/pages/BlogPostPage";
import InboxPage from "@/pages/InboxPage";
import { ChatWidget } from "@/components/ChatWidget";
import { useLocation } from "react-router-dom";

// Exposes react-router's navigate to non-hook helpers (see lib/nav.js)
const NavigateBridge = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.__navigate = navigate;
    return () => { window.__navigate = null; };
  }, [navigate]);
  return null;
};

// Chat bubble on every public page (not the private inbox)
const ChatMount = () => {
  const { pathname } = useLocation();
  return pathname.startsWith("/inbox") ? null : <ChatWidget />;
};

// Old Wix blog URLs: /post/<slug> -> /blog/<slug>
const LegacyPostRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/blog/${slug}`} replace />;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <NavigateBridge />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/toolkit/:slug" element={<NichePage />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="/making-tax-digital" element={<MtdPage />} />
        <Route path="/blog" element={<BlogIndexPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/post/:slug" element={<LegacyPostRedirect />} />
        <Route path="/inbox" element={<InboxPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ChatMount />
      <Toaster position="bottom-center" richColors />
    </BrowserRouter>
  );
}

export default App;
